import styled from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
export const PhoneInputContainer = styled.div `
  display: ${(props) => (props.$stretch ? 'flex' : 'inline-flex')};
  flex-direction: column;
`;
export const PhoneInputLabel = styled.label `
  display: inline-block;
  font: ${theme.fontRole.label};
  color: ${theme.semantic.foreground.tertiary};
`;
export const PhoneInputDescription = styled.div `
  font: ${theme.fontRole.bodySm};
  color: ${theme.semantic.text[100]};
`;
export const Container = styled.div `
  display: flex;
`;
export const SelectContainer = styled.div `
  margin-right: ${theme.spacing.md};
  flex: 0 0 20%;
  min-width: ${pxToRem(100)};
`;
export const InputContainer = styled.div `
  flex: 1 1 80%;
`;
